import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import { TELEPHONE } from 'constants/objects/telephone'
import { Edit } from '@material-ui/icons'
import { phoneNumber } from 'utils/format'
import { PhonesForm } from 'components/Customer/PhonesForm'
import { Card } from 'ui-components/Card'
import { CardTitle } from 'ui-components/CardTitle'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { SlideDialog } from 'ui-components/SlideDialog'
import { TelephoneList, EditButton } from './styles'

export default function TelephoneInfo(props) {
  const {
    telephones,
    onSave,
    saving,
  } = props

  const [toEdit, setToEdit] = useState(false)
  const [saved, setSaved] = useState(true)

  useEffect(() => {
    setToEdit(!saved)
  }, [saved])

  useEffect(() => {
    setSaved(!saving)
  }, [saving])

  const renderTelephone = (telephone, index) => (
    <DescItemInfo
      key={`telephone-list-${index}`}
      label={telephone.description || 'Telefone'}
    >
      {phoneNumber(telephone.number)}
    </DescItemInfo>
  )

  const renderTelephones = () => {
    if (!telephones?.length || isEqual(telephones, [TELEPHONE, TELEPHONE])) {
      return (
        <DescItemInfo label="Telefone">
          Nenhum telefone registrado
        </DescItemInfo>
      )
    }

    return telephones.map((item, index) => (
      item.number ? renderTelephone(item, index) : null
    ))
  }

  return (
    <Card>
      <SlideDialog
        open={toEdit}
        onClose={() => setToEdit(false)}
      >
        <PhonesForm
          telephones={telephones}
          onCancel={() => setToEdit(false)}
          onSave={onSave}
          saving={saving}
        />
      </SlideDialog>

      <CardTitle title="Telefones" noMargin />

      <TelephoneList>
        <div>
          {renderTelephones()}
        </div>

        <EditButton
          buttonType="icon"
          onClick={() => setToEdit(true)}
        >
          <Edit />
        </EditButton>
      </TelephoneList>
    </Card>
  )
}

TelephoneInfo.propTypes = {
  telephones: PropTypes.arrayOf(PropTypes.object),
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

TelephoneInfo.defaultProps = {
  telephones: [],
  saving: false,
}
